export const GET_AGENDAS_STARTED = 'GET_AGENDAS_STARTED';
export const GET_AGENDAS_SUCCESS = 'GET_AGENDAS_SUCCESS';
export const GET_AGENDAS_ERROR = 'GET_AGENDAS_ERROR';

export const GET_AORDERS_STARTED = 'GET_AORDERS_STARTED';
export const GET_AORDERS_SUCCESS = 'GET_AORDERS_SUCCESS';
export const GET_AORDERS_ERROR = 'GET_AORDERS_ERROR';